export default __webpack_public_path__ + "static/media/hinh-nho-4.e2c8486e.png";